<svg
  width="16"
  height="16"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M20 20V21H21V20H20ZM4 20H3V21H4V20ZM4 4V3H3V4H4ZM11 5H12V3H11V5ZM21 13V12H19V13H21ZM19.4142 4.58579C20.1953 5.36683 20.1953 6.63317 19.4142 7.41421L20.8284 8.82843C22.3905 7.26633 22.3905 4.73367 20.8284 3.17157L19.4142 4.58579ZM19.4142 7.41421C18.6332 8.19526 17.3668 8.19526 16.5858 7.41421L15.1716 8.82843C16.7337 10.3905 19.2663 10.3905 20.8284 8.82843L19.4142 7.41421ZM16.5858 7.41421C15.8047 6.63317 15.8047 5.36683 16.5858 4.58579L15.1716 3.17157C13.6095 4.73367 13.6095 7.26633 15.1716 8.82843L16.5858 7.41421ZM16.5858 4.58579C17.3668 3.80474 18.6332 3.80474 19.4142 4.58579L20.8284 3.17157C19.2663 1.60948 16.7337 1.60948 15.1716 3.17157L16.5858 4.58579ZM20 19H4V21H20V19ZM5 20V4H3V20H5ZM4 5H11V3H4V5ZM19 13V20H21V13H19Z"
    fill="currentColor"
  />
</svg>
